import { BaseQueryParams } from '@/app/core/services/http';

export enum UserRole {
  SuperAdmin = 'super_admin',
  Admin = 'admin',
  Manager = 'manager',
  Bookkeeper = 'bookkeeper',
}

export interface User {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  role: UserRole;
  created_at: string;
  updated_at: string;
}

export interface UsersFiltersQueryParams {
  created_at_from?: string;
  created_at_to?: string;
  ids?: number[];
}

export type UserListQueryParams = BaseQueryParams & UsersFiltersQueryParams;

export type CreateUpdateUserRole = Exclude<UserRole, UserRole.SuperAdmin>;

export interface CreateUserPayload {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  password_confirmation: string;
  role: CreateUpdateUserRole;
}

export interface UpdateUserPayload {
  first_name?: string;
  last_name?: string;
  role?: CreateUpdateUserRole;
}

export interface ResetUserPasswordPayload {
  password: string;
  password_confirmation: string;
}
